import styled from "styled-components";
import { marginable } from "styles/styledComponentsMixins";

const Divider = styled.div`
	margin: 0.35rem 0;
	background: ${({ theme: { colors } }) => colors.buttonsDefaultGrey};
	height: var(--size-grid-small);
	width: 100%;
	${marginable.css}
`;

export default Divider;
